export default "__VITE_ASSET__fTeI5RIV__"